/*
 * Lumera hareket katmanı (küçük, bağımlılıksız).
 * 1) [data-lum-reveal]: görünüme girince bir kez belirir. İlk ekrandakiler anında görünür (titreme yok).
 * 2) [data-lum-colorways]: renk çipleri görseli / adı / fiyatı / bağlantıyı değiştirir.
 * 3) [data-lum-tap]: dokunmatik ekranda karta dokununca .is-active (masaüstündeki :hover karşılığı).
 * prefers-reduced-motion: reveal kapalı, geçişler CSS'te kısaltılır.
 */
(() => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(scope = document) {
    const items = scope.querySelectorAll('[data-lum-reveal]:not(.is-in)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    root.classList.add('lum-js');
    const vh = window.innerHeight;
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      },
      // threshold 0: bölümün üst kenarı ekranın alt %8'ini geçince tetiklenir. Oranlı eşik (ör. 0.12)
      // ekrandan uzun bölümlerde (mobilde yorum ızgarası) hiç sağlanmaz ve bölüm görünmez kalır.
      { rootMargin: '0px 0px -8% 0px', threshold: 0 }
    );
    items.forEach((el) => {
      // İlk ekranda olanlar gecikmesiz, geçişsiz görünür
      if (el.getBoundingClientRect().top < vh * 0.92) {
        el.classList.add('is-in', 'is-instant');
      } else {
        io.observe(el);
      }
    });
  }

  function initColorways(scope = document) {
    scope.querySelectorAll('[data-lum-colorways]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = '1';
      const frames = section.querySelectorAll('[data-frame]');
      const buttons = section.querySelectorAll('.lum-swatch');
      const nameEl = section.querySelector('[data-colorways-name]');
      const priceEl = section.querySelector('[data-colorways-price]');
      const linkEl = section.querySelector('[data-colorways-link]');

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const i = btn.dataset.index;
          buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
          frames.forEach((f) => {
            const on = f.dataset.frame === i;
            f.classList.toggle('is-active', on);
            f.toggleAttribute('aria-hidden', !on);
          });
          if (nameEl) nameEl.textContent = btn.dataset.name;
          if (priceEl) priceEl.textContent = btn.dataset.price;
          if (linkEl) linkEl.href = btn.dataset.url;
        });
      });
    });
  }

  // [data-lum-tap]: dokunmatik ekranda kartın üzerine gelme halini dokunuşla açar/kapatır
  function initTap() {
    if (root.dataset.lumTap) return;
    root.dataset.lumTap = '1';
    const touch = window.matchMedia('(hover: none)');
    document.addEventListener('click', (e) => {
      if (!touch.matches) return;
      const card = e.target.closest('[data-lum-tap]');
      document.querySelectorAll('[data-lum-tap].is-active').forEach((el) => {
        if (el !== card) el.classList.remove('is-active');
      });
      if (card) card.classList.toggle('is-active');
    });
  }

  const init = (scope) => {
    initReveal(scope);
    initColorways(scope);
    initTap();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Tema düzenleyici: bölüm yeniden yüklenince tekrar bağla
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
